module.exports = __webpack_public_path__ + "static/media/unify-close.2bd78dcd.svg";